import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import { App } from './App.tsx';
import { AppProviders } from './providers.tsx';
import { createApiClient } from './lib/api.ts';
import { tokenHolder } from './lib/tokenStore.ts';
import { createQueryClient } from './lib/queryClient.ts';
import { SESSION_EXPIRED_EVENT } from './auth/AuthContext.tsx';

const apiClient = createApiClient({
  tokenHolder,
  // When a silent refresh fails, tell the app to drop the session; the auth
  // provider listens for this and the protected routes bounce to /login.
  onSessionExpired: () => window.dispatchEvent(new Event(SESSION_EXPIRED_EVENT)),
});

const queryClient = createQueryClient();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AppProviders client={apiClient} queryClient={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </AppProviders>
  </StrictMode>,
);
